import { Interval } from '@shared/utils/History/Interval';
import { HistoryMerger } from './HistoryMerger';
export class HistoryMergerBasedByDay extends HistoryMerger {
    constructor(inputParams) {
        super(inputParams);
    }
    FindIntervalBorders(date) {
        // Date - начало дня должно быть при любых раскладах с учетом офсета сессии
        const dateTime = this.session.ConvertDateToSessionDateTime(date).startOf('day');
        const startSessionDate = dateTime.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        // нужно конвертировать DateTime в тайзону сессии с учетом оффсета
        let from = startSessionDate;
        while (!this.IsStartPeriodDate(from)) {
            from = from.minus({ days: 1 });
        }
        const to = from.plus({ days: this.GetDaysInPeriod(from) });
        const result = new Interval();
        result.From = this.session.ConvertSessionDateTimeToDate(from);
        result.To = this.session.ConvertSessionDateTimeToDate(to);
        return result;
    }
    GetCount() {
        return this.newPeriod / this.GetBasePeriod();
    }
}
